/*
 * @Description:
 * @Date: 2021-06-25 10:25:49
 */

import TableSearchMixin from './table-search.js';
import { twoDecimal } from '@/tools/money';
import TableField from '../components/table-field.vue';

import TableHandler from '../components/table-handler.vue';

import TableTopHandler from '../components/table-top-handler.vue';
import dateFormat from '@/tools/dateFormat';

const toTaskRecord = function(row) {
  const { href } = this.$router.resolve({
    query: {
      ...this.$route.query,
      activeTask: 'recordList',
      fullName: row.fullName
    }
  });
  location.href = `?t=${Date.now()}${href}`;
};
export default {
  mixins: [TableSearchMixin],
  components: { TableField, TableHandler, TableTopHandler },
  created() {
    const { fullName, phone } = this.$route.query;
    fullName && (this.searchQuery.fullName = fullName);
    phone && (this.searchQuery.phone = phone);
    this.createField();
  },
  computed: {
    taskSumMixin_projectType() {
      return this.$store.state.homeProject.projectType;
    },
    taskSumMixin_taxCollectionPattern() {
      return this.$store.state.homeProject.taxCollectionPattern;
    }
  },
  data() {
    return {
      taskRecordMixin_fields: []
    };
  },
  methods: {
    createField() {
      let fields = [
        {
          label: '序号',
          width: '80px',

          prop: 'index',
          render: (h, ctx, row, column, index, no) => {
            return <span>{no + 1}</span>;
          }
        },
        {
          prop: 'projectName',
          label: '项目名称',
          width: 225
        },
        {
          prop: 'fullName',
          label: '项目参与人',
          width: 140,
          render: (h, ctx, row) => {
            return (
              <el-button type="text" onClick={toTaskRecord.bind(this, row)}>
                {row.fullName}
              </el-button>
            );
          }
        },
        {
          prop: 'personName',
          label: '个体',
          width: 140,
          hidden: this.taskSumMixin_taxCollectionPattern !== 5
        },
        {
          prop: 'phone',
          label: '手机号',
          width: 120,
          render: (h, ctx, row) => {
            function mobileFilter(val) {
              let reg = /^(.{3}).*(.{4})$/;
              return val.replace(reg, '$1****$2');
            }
            return <span>{mobileFilter(row.phone)}</span>;
          }
        },
        {
          hidden: !this.$checkNeedUserTag(this.$store.state.homeProject),
          prop: 'userTag',
          label: '人员标签',
          width: 120,
          formatter(row, c, v) {
            return v || '未设置';
          }
        },
        {
          prop: 'isExecute',
          label: '是否可执行项目',
          formatter(row, c, v) {
            return ['否', '是'][+v] || '-';
          },
          width: 120
        },
        {
          prop: 'isSettlement',
          label: '是否可结算',
          formatter(row, c, v) {
            return ['不可结算', '可结算'][v];
          },
          width: 120
        },
        {
          prop: 'isCurrPeriod',
          label: '是否当期人员',
          formatter(row, c, v) {
            return ['否', '是'][v];
          },
          width: 120
        },
        {
          prop: 'userAuthStatus',
          label: '认证状态',
          width: 120
        },
        // {
        //   prop: 'occupationAuthStatus',
        //   label: '职业认证',
        //   render(h, ctx, row) {
        //     return (
        //       <OccupationAuthStatus
        //         occupationAuthStatus={row.occupationAuthStatus}
        //         userId={row.userId}
        //       />
        //     );
        //   }
        // },
        {
          prop: 'taskDt',
          label: '预采购时间',
          width: 120,
          hidden: this.taskSumMixin_projectType === 19,
          formatter(row, c, v) {
            return v ? dateFormat(v, 'YYYY-MM-DD') : '-';
          }
        },
        {
          prop: 'prePurchaseNum',
          label: '剩余预采购任务量',
          width: 120,
          hidden: this.taskSumMixin_projectType === 19,
          formatter(row, c, v) {
            return v || '0';
          }
        },
        {
          prop: 'industryNum',
          label: '工业接收任务量',
          width: 120,
          formatter(row, c, v) {
            return v || '0';
          }
        },
        {
          prop: 'passingNum',
          label: '待审核任务量',
          width: 120,
          formatter(row, c, v) {
            return v || '0';
          }
        },
        {
          label: '系统接收中任务量',
          width: 200,
          prop: ' passingTaskSumPlatform',
          render: (h, ctx, row) => {
            return (
              <span>
                {Number.isFinite(row.passingTaskSumPlatform)
                  ? row.passingTaskSumPlatform
                  : '-'}
              </span>
            );
          }
        },
        {
          label: '系统已接收任务量',
          width: 180,
          prop: 'passedTaskSumPlatform',
          render: (h, ctx, row) => {
            return (
              <span>
                {Number.isFinite(row.passedTaskSumPlatform)
                  ? row.passedTaskSumPlatform
                  : '-'}
              </span>
            );
          }
        },
        {
          prop: 'noFinishNum',
          label: '未完成任务量',
          width: 120,
          formatter(row, c, v) {
            return v || '0';
          }
        },
        {
          prop: 'noPassNum',
          label: '审核未通过任务量',
          width: 130,
          formatter(row, c, v) {
            return v || '0';
          }
        },
        {
          prop: 'taskProgress',
          label: '预采购任务量完成进度',
          hidden: this.taskSumMixin_projectType === 19,
          width: 200,
          render: (h, ctx, row) => {
            const process = row.taskProgress;
            return Number.isFinite(process) ? (
              <el-progress
                stroke-width={10}
                percentage={process}
                color={'#FF8B3C'}
              >
                <span style={{ fontSize: '12px' }}>{process}%</span>
              </el-progress>
            ) : (
              <span>{'-'}</span>
            );
          }
        },
        {
          prop: 'taskSumNoFinishPrice',
          label: '预采购金额（含税）',
          width: 130,
          render: (h, ctx, row) => {
            return (
              <span>
                {!['', null, undefined].includes(row.taskSumNoFinishPrice)
                  ? twoDecimal(row.taskSumNoFinishPrice, 100, '元')
                  : '-'}
              </span>
            );
          }
        },
        {
          prop: 'taskSumPassedCsoPrice',
          label: '预计项目结算金额（含税）',
          width: 130,
          render: (h, ctx, row) => {
            return <span>{row.taskSumPassedCsoPrice + '元'}</span>;
          }
        },
        {
          prop: 'invalidTaskNum',
          label: '过期任务量',
          width: 120,
          formatter(row, c, v) {
            return v || '0';
          }
        }
      ];
      this.taskRecordMixin_fields = fields;
    }
  }
};
